
const Validators = {

	mkpasswd (key, value, vars){
		switch(key){
			case "length":
				value = parseInt(value, 10);
				if(Number.isNaN(value)) return new Error("桁数は数値で入力してください");
				if(value > 64 || value < 8) return new Error("桁数は8-64の数値で入力してください");
				break;
			case "count":
				value = parseInt(value, 10);
				if(Number.isNaN(value)) return new Error("生成数は数値で入力してください");
				if(value < 1 || value > 128) return new Error("生成数は1-128の数値で指定してください");
				break;
			default: break;
		}
		return true;
	}

};

const Validation = {

	get (name){
		var func = Validators[name] || $.noop,
			test = function(vars, errors){
				var count = 0;
				Object.keys(vars)
				.map(function(key){
					var e = func(key, vars[key], vars);
					if(true !== e){
						errors[key] = e; 
						count += 1;
					} else {
						errors[key] = null;
					}
				});
				return ! count;
			};

		return { test };
	}

};


export default Validation;



// WEBPACK FOOTER //
// ./src/js/lib/validation.js